export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes/';
export const TIMEOUT_SEC = 8;
export const RES_PER_PAGE = 8;
export const KEY = '0cd03313-20e9-4453-8212-8450073a63d6';
export const MODAL_CLOSE_SEC = 2;